import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

const ranking = [...comics].sort((a, b) => b.views - a.views).slice(0, 8);

const rankColor = (i: number) => {
  if (i === 0) return "bg-accent-500 text-background-50";
  if (i === 1) return "bg-accent-400 text-background-50";
  if (i === 2) return "bg-accent-300 text-accent-950";
  return "bg-background-200 text-foreground-600";
};

export default function PopularRank() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-3 flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-700">
          <i className="ri-fire-line text-lg" />
        </span>
        <h2 className="text-lg font-bold text-foreground-950">人气榜单</h2>
      </div>

      <ol className="flex flex-col">
        {ranking.map((comic, i) => (
          <li key={comic.id}>
            <Link
              to={`/detail/${comic.id}`}
              className="group flex items-center gap-3 rounded-md px-1 py-2 transition-colors hover:bg-primary-50"
            >
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${rankColor(i)}`}
              >
                {i + 1}
              </span>
              <div className="h-14 w-11 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={comic.cover}
                  alt={`${comic.title} 韩漫封面`}
                  title={`${comic.title} 免费韩漫在线阅读`}
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="min-w-0 flex-1">
                <p className="line-clamp-1 text-sm font-medium text-foreground-900 group-hover:text-primary-700">
                  {comic.title}
                </p>
                <p className="mt-0.5 line-clamp-1 text-xs text-foreground-500">
                  {comic.author} · {comic.categories[0]}
                </p>
              </div>
              <span className="shrink-0 rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800">
                {comic.rating}
              </span>
            </Link>
          </li>
        ))}
      </ol>

      <div className="mt-4 rounded-lg bg-primary-50 p-4">
        <p className="flex items-center gap-1.5 text-sm font-semibold text-primary-800">
          <i className="ri-gift-line" />
          全站免费阅读
        </p>
        <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">
          无需付费与注册，登录纯属可选，打开即可畅读全部韩漫章节。
        </p>
      </div>
    </section>
  );
}